<script>
import LanguageLabel from '@/js/components/common/labels/LanguageLabel';

export default {
    name: 'DocumentAuthors',

    functional: true,

    props: {
        document: {type: Object, required: true},
    },

    render(createElement, {props, data, parent}) {
        const authors = String(props.document.authors || '')
            .split(/[\r\n,;-]/g)
            .map((author) => {
                author = author.trim();

                if (!author) {
                    return false;
                }

                return author;
            })
            .filter((author) => author !== false);

        return createElement('span', data, [
            createElement(LanguageLabel, {
                props: {
                    languages: props.document.authors_language,
                    hideName: true,
                    none: parent.$t('documents.authors.empty-language'),
                },
            }),
            authors.length === 0 ? parent.$t('documents.authors.empty') : authors.join(', '),
        ]);
    },
};
</script>
